import PropTypes from 'prop-types'
import { forwardRef } from 'react'
import LinkButton from '../ui/LinkButton'
import styles from './BordeDetalle.module.css'

const BordeDetalle = forwardRef(
  ({ className = '', vieneDeTiendas, titulo, categoriaLinks, onCerrarClick, children }, ref) => {
    return (
      <fieldset
        ref={ref}
        className={`${className} ${vieneDeTiendas ? styles.fieldsetBordeDetalle : 'fieldset'}`}
      >
        <div className={styles.flex}>
          <legend>
            {categoriaLinks?.length > 0 ? (
              <span className={styles.categoriaPath}>
                <span className={styles.categoriaLabel}>Categoría: </span>
                {categoriaLinks.map((cat, index) => (
                  <span key={cat.id}>
                    <span
                      className={styles.categoriaLink}
                      onClick={() => cat.onClick()}
                      role="button"
                      tabIndex={0}
                      onKeyDown={(e) => e.key === 'Enter' && cat.onClick()}
                    >
                      {cat.name}
                    </span>
                    {index < categoriaLinks.length - 1 && (
                      <span className={styles.categoriaSeparador}> &gt; </span>
                    )}
                  </span>
                ))}
              </span>
            ) : (
              titulo
            )}
          </legend>
          <LinkButton onClick={onCerrarClick} className={`btn x-times ${styles.closeIcon}`}>
            <i className={`fa fa-times ${styles.size}`} aria-hidden="true" />
          </LinkButton>
        </div>
        {children}
      </fieldset>
    )
  }
)

BordeDetalle.displayName = 'BordeDetalle'
BordeDetalle.propTypes = {
  className: PropTypes.string,
  vieneDeTiendas: PropTypes.bool,
  titulo: PropTypes.string.isRequired,
  categoriaLinks: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired
    })
  ),
  onCerrarClick: PropTypes.func.isRequired,
  children: PropTypes.node
}

export default BordeDetalle
